import type { vendorApiNames } from '../names';
import type { UsernamePasswordAuthentication } from './auth';
import type {
  BaseUpdateVendorApiSettings,
  BaseUrl,
  BaseVendorApi,
  CombinedDiscovery,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';

export interface VersaDiscoverySettings {
  paginationLimit?: number;
}

/**
 * Versa API settings available from API
 */
export type PublicVersaApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['versa']
> &
  CombinedDiscovery &
  RejectUnauthorized &
  BaseUrl &
  VendorApiHttpAgentSettings &
  VendorApiHttpAdvancedSettings &
  VersaDiscoverySettings;

/**
 * Versa API settings available in backend
 */
export type VersaApiSettings = PublicVersaApiSettings &
  UsernamePasswordAuthentication;

/**
 * Versa API settings expected on API when updating
 */
export type UpdateVersaApiSettings = BaseUpdateVendorApiSettings<
  PublicVersaApiSettings,
  UsernamePasswordAuthentication
>;
